import path from './icons/path.svg';
import pathActive from './icons/pathActive.svg';
import dropDown from './icons/dropDown.svg';
import dropDownV from './icons/dropDownV.svg';
import VIcon from './icons/V.svg';
import Search from './icons/search.svg';
import ArrowLeft from './icons/arrowLeft.svg';
import separator from './icons/separator.svg';
import toggleOff from './icons/toggleOff.svg';
import toggleOn from './icons/toggleOn.svg';
import logo from './icons/logo.svg';
import portuguese from './icons/Portuguese.svg';
import date from './icons/date.svg';
import leftArrow from './icons/leftArrow.svg';
import arrowRight from './icons/rightArrow.svg';
import filter from './icons/filter.svg';
import arrowUp from './icons/arrowUp.svg';
import arrowDown from './icons/arrowDown.svg';
import userAvatar from './icons/userAvatar.svg';
import logoIcon from './icons/logotext.svg';
import districts from './icons/districts.svg';
import schools from './icons/schools.svg';
import history from './icons/history.svg';
import userManagement from './icons/userManagement.svg';
import deals from './icons/deal.svg';
import x from './icons/X.svg';
import arrowUpActive from './icons/up.svg';
import arrowDownActive from './icons/down.svg';
import pencil from './icons/pencil.svg';
import deleteIcon from './icons/trash.svg';
import checkCircle from './icons/checkCircle.svg';
import cloudUpload from './icons/cloudUpload.svg';
import download from './icons/download.svg';
import whiteV from './icons/whiteV.svg';
import classReport from './icons/report.svg';
import diamond from './icons/diamond.svg';
import star from './icons/star.svg';
import avg from './icons/avg.svg';
import Districtactive from './icons/districtActive.svg';
import schoolActive from './icons/schoolsActive.svg';
import dealsDefualt from './icons/dealsDefualt.svg';
import historyActive from './icons/historyActive.svg';
import settings from './icons/settings.svg';
export const icons = {
  path,
  pathActive,
  dropDown,
  dropDownV,
  VIcon,
  Search,
  ArrowLeft,
  separator,
  toggleOn,
  toggleOff,
  logo,
  portuguese,
  date,
  leftArrow,
  arrowRight,
  filter,
  arrowUp,
  arrowDown,
  userAvatar,
  logoIcon,
  districts,
  schools,
  history,
  userManagement,
  deals,
  x,
  arrowUpActive,
  arrowDownActive,
  pencil,
  deleteIcon,
  checkCircle,
  cloudUpload,
  download,
  whiteV,
  classReport,
  diamond,
  star,
  avg,
  Districtactive,
  schoolActive,
  dealsDefualt,
  historyActive,
  settings,
};
